import firebase from '../firebase/firebase';
const db = firebase.database();

export const sendOnScreenCompanyNotification = ({companyId, type, title, message}) => {
    db.ref(`providerCompanies/${companyId}/messageQueue/`).push({type: type, title: title, message: message});
}


// WEBPACK FOOTER //
// ./src/js/utils/notificationUtils.js